export const BASE64_CHARS = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-_";
const mask = 63;
export function randomBase64(length, characters) {
    const bufLen = Math.ceil(length / 4) * 3;
    const buf = new Uint8Array(bufLen);
    window.crypto.getRandomValues(buf);
    const result = [];
    for (let i = 0; i < bufLen; i += 3) {
        const l = buf[i];
        const m = buf[i + 1];
        const r = buf[i + 2];
        result.push(characters[(l >>> 2) & mask], characters[(l << 4 | m >>> 4) & mask], characters[(m << 2 | r >>> 6) & mask], characters[r & mask]);
    }
    return result.join("").substring(0, length);
}
export function uniqueDomId() {
    return "ktm-" + randomBase64(16, BASE64_CHARS);
}
export const MINUTE = "minute";
export const HOUR = "hour";
export const DAY = "day";
export const WEEK = "week";
export const MINUTES = "minutes";
export const HOURS = "hours";
export const DAYS = "days";
export const WEEKS = "weeks";
export const PIXELS = "px";
//# sourceMappingURL=utils.js.map